import { StyledBody } from 'baseui/card'
import { ParagraphMedium } from 'baseui/typography'
import IconCarbonLightning from '@/shared/icons/IconCarbonLightning'
import IconCarbonSatelliteRadar from '@/shared/icons/IconCarbonSatelliteRadar'
import IconCarbonRule from '@/shared/icons/IconCarbonRule'
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import SDNotification from '@/shared/components/SDComponents/SDNotification'
import { useTranslation } from 'react-i18next'
import { BlueCard, Card } from '@/shared/theme/styled-components'
import { StyledHeader, StyledTitle } from '@/shared/components/Panel/styled-components'

const ErrorPage = ({ currentCountry, currentType, hasErrorType, hasErrorCountry }) => {
  const { t } = useTranslation()

  return (
    <main id='main'>
      {hasErrorType && currentType !== '' && (
        <SDNotification type='warning'>{t('common:error_type_access').replace('#TYPE#', currentType)}</SDNotification>
      )}
      {hasErrorCountry && (
        <SDNotification type='warning'>
          {t('common:error_country_access').replace('#COUNTRY#', currentCountry)}
        </SDNotification>
      )}
      <BlueCard>
        <FlexGrid flexGridColumnCount={2} flexGridColumnGap='scale800' flexGridRowGap='scale800'>
          <FlexGridItem>
            <a href='/energie' id='button-access-energy'>
              <Card>
                <StyledHeader>
                  <StyledTitle>
                    <IconCarbonLightning size={24} /> {t('common:energy_title')}
                  </StyledTitle>
                </StyledHeader>
                <StyledBody>
                  <ParagraphMedium>{t('common:go_to_energy')}</ParagraphMedium>
                </StyledBody>
              </Card>
            </a>
          </FlexGridItem>
          <FlexGridItem>
            <a href='/telecom' id='button-access-telecom'>
              <Card>
                <StyledHeader>
                  <StyledTitle>
                    <IconCarbonSatelliteRadar size={24} /> {t('common:telecom_title')}
                  </StyledTitle>
                </StyledHeader>
                <StyledBody>
                  <ParagraphMedium>{t('common:go_to_telecom')}</ParagraphMedium>
                </StyledBody>
              </Card>
            </a>
          </FlexGridItem>
        </FlexGrid>
        <FlexGrid flexGridColumnCount={2} flexGridColumnGap='scale800' flexGridRowGap='scale800'>
          <FlexGridItem>
            <a href='/assurance' id='button-access-insurance'>
              <Card>
                <StyledHeader>
                  <StyledTitle>
                    <IconCarbonRule size={24} /> {t('common:insurance_title')}
                  </StyledTitle>
                </StyledHeader>
                <StyledBody>
                  <ParagraphMedium>{t('common:go_to_insurance')}</ParagraphMedium>
                </StyledBody>
              </Card>
            </a>
          </FlexGridItem>
        </FlexGrid>
      </BlueCard>
    </main>
  )
}

export default ErrorPage
